import { createAuth0 } from "@auth0/auth0-vue";
import { handleEnvVars } from "@/config/apiClient.config.ts";
const {
  auth0Domain,
  auth0Audience,
  auth0ClientId,
  auth0CallbackUrl,
  auth0Scopes,
} = handleEnvVars(import.meta.env);

export const auth0Instance = createAuth0(
  {
    domain: auth0Domain,
    clientId: auth0ClientId,

    cacheLocation: "memory",
    useRefreshTokens: true,
    useRefreshTokensFallback: true,

    authorizationParams: {
      redirect_uri: `${window.location.origin}${auth0CallbackUrl}`,
      audience: auth0Audience,
      oauthTokenScope: "openid profile email",
      scope: `${auth0Scopes} offline_access`,
    },
  },
  {
    errorPath: "/auth-error",
  },
);

export const getAccessToken = async (options?: {
  cacheMode?: "on" | "off" | "cache-only";
}): Promise<string> => {
  return await auth0Instance.getAccessTokenSilently(options);
};

export const handleAuthFailure = async (): Promise<void> => {
  await auth0Instance.loginWithRedirect({
    appState: { target: window.location.pathname },
  });
};

export const reauthenticate = async (): Promise<void> => {
  await auth0Instance.loginWithPopup({
    authorizationParams: {
      acr_values:
        "http://schemas.openid.net/pape/policies/2007/06/multi-factor",
    },
  });
};
